<template>
    <div class="page-container">
        <span class="page-place-holder"></span>
        <span class="page-items">
            <span @click="prev" class="prev" :class="[currentPage !== 1?``:`hidden-item`]"><span class="content"><</span></span>
            <span class="page-item" v-for="i in pageSize" :key="i"
                  :class="[i === currentPage ? `selected`:``]">{{i}}</span>
            <span @click="next" class="prev" :class="[currentPage !== this.pageSize ?``:`hidden-item`]">></span>
        </span>
        <span class="page-place-holder"></span>
    </div>
</template>

<script>
    export default {
        name    : "Page",
        props   : {
            pageSize   : 0,
            currentPage: 0
        },
        methods : {
            prev() {
                if (this.currentPage > 1) {
                    this.$emit("pageChanged", -1)
                }
            },
            next() {
                if (this.currentPage <= this.pageSize) {
                    this.$emit("pageChanged", 1)
                }
            }
        },
        computed: {}
    }
</script>

<style lang="scss" scoped>
    .page-container {
        display: flex;
        flex-direction: row;
        color: white;

        .page-place-holder {
            flex: 1;
        }

        .page-items {
            flex-direction: row;

            .page-item {
                color: #999999;
                width: 20px;
                height: 20px;
                margin-left: 5px;
                margin-right: 5px;
                text-align: center;
                display: inline-block;
                border-radius: 50%;

                &.selected {
                    color: #000;
                    background-color: #FFFFFF;
                }
            }


            .prev {
                text-align: center;
                color: #FFFFFF;
                padding: 10px 20px;
                width: 30px;
                height: 30px;
                min-width: 30px;
                min-height: 30px;
                justify-content: center;
                align-items: center;

                .content {
                    flex: 1;
                }
            }
        }
    }

    .hidden-item {
        visibility: hidden;
    }
</style>